export default {"src":"/_next/static/media/logo.bdc9c12a.svg","height":319,"width":319,"blurWidth":0,"blurHeight":0};